import * as React from 'react';
import { SVGProps } from 'react';
const HistoricNoData = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="46"
    height="48"
    viewBox="0 0 46 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line x1="7" y1="16" x2="24" y2="16" stroke="white" strokeWidth="2" />
    <rect
      x="11.6"
      y="6.68555"
      width="34.4"
      height="38.0857"
      rx="2"
      fill="#99ACC2"
    />
    <rect
      x="9.64282"
      y="9.64258"
      width="33.4"
      height="37.0857"
      rx="2.5"
      fill="#99ACC2"
      stroke="#F5F8FA"
    />
    <g clipPath="url(#clip0_4585_13052)">
      <circle cx="9.00002" cy="9.00039" r="8.1" fill="#F3F5FD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.2778 2.00897L4.39872 1.24059C4.44653 0.93403 4.23843 0.64575 3.93187 0.597094C3.62531 0.548438 3.33561 0.757967 3.2878 1.06481L2.93623 3.28697C2.88561 3.59382 3.09659 3.8821 3.40315 3.93047L5.625 4.28259C5.93156 4.33125 6.22126 4.12172 6.26907 3.81487C6.31689 3.50831 6.10872 3.22003 5.80215 3.17138L4.80377 3.01331C5.99065 2.178 7.43906 1.6875 9 1.6875C13.0359 1.6875 16.3125 4.96406 16.3125 9C16.3125 13.0359 13.0359 16.3125 9 16.3125C4.96406 16.3125 1.6875 13.0359 1.6875 9C1.6875 8.6895 1.43437 8.4375 1.125 8.4375C0.815625 8.4375 0.5625 8.6895 0.5625 9C0.5625 13.6567 4.3425 17.4375 9 17.4375C13.6575 17.4375 17.4375 13.6567 17.4375 9C17.4375 4.34334 13.6575 0.5625 9 0.5625C7.25063 0.5625 5.62499 1.09603 4.2778 2.00897ZM8.4375 3.375V9C8.4375 9.14906 8.49659 9.29222 8.60346 9.39769L11.416 12.2102C11.6353 12.4298 11.9897 12.4298 12.209 12.2102C12.4312 11.9908 12.4312 11.6342 12.209 11.4148L9.5625 8.76712V3.375C9.5625 3.0645 9.30937 2.8125 9 2.8125C8.69063 2.8125 8.4375 3.0645 8.4375 3.375Z"
        fill="#99ACC2"
      />
    </g>
    <path
      d="M31.0001 29.6562L37 35.6561"
      stroke="white"
      strokeLinecap="round"
    />
    <path
      d="M37 29.6533L31.0001 35.6532"
      stroke="white"
      strokeLinecap="round"
    />
    <line x1="17" y1="21" x2="34" y2="21" stroke="white" strokeWidth="2" />
    <line x1="17" y1="28" x2="29" y2="28" stroke="white" strokeWidth="2" />
    <line x1="17" y1="35" x2="26" y2="35" stroke="white" strokeWidth="2" />
    <defs>
      <clipPath id="clip0_4585_13052">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default HistoricNoData;
